
function addGoogleTagManager(gtmKey) {
	if (!gtmKey) {
		return;
	}
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ 'gtm.start': new Date().getTime(), event:'gtm.js' });
	var f = document.getElementsByTagName('script')[0],
		j = document.createElement('script');
	j.async = true;
	j.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmKey;
	f.parentNode.insertBefore(j, f);
};

export default {
	addGoogleTagManager
};



// WEBPACK FOOTER //
// ./src/modules/google-tag-manager.js